module.exports = __webpack_public_path__ + "static/media/young-adults.0a4530d7.jpg";